export const HOME = {
  emergentLink: "home-emergent-link",
  heroQuoteBtn: "home-hero-quote-btn",
  heroExploreBtn: "home-hero-explore-btn",
  collegeTracksBtn: "home-college-tracks-btn",
  groupTravelBtn: "home-group-travel-btn",
  offersSection: "home-offers-section",
  featuredSection: "home-featured-section",
  whyUsSection: "home-whyus-section",
  testimonialSection: "home-testimonial-section",
  ctaBanner: "home-cta-banner",
};

export const NAV = {
  brand: "nav-brand",
  linkTours: "nav-link-college-tours",
  linkGroupTravel: "nav-link-group-travel",
  linkAbout: "nav-link-about",
  linkWhy: "nav-link-why",
  linkContact: "nav-link-contact",
  quoteBtn: "nav-quote-btn",
  mobileToggle: "nav-mobile-toggle",
};

export const TOURS = {
  list: "tours-list",
  filterAll: "tours-filter-all",
  filterCollege: "tours-filter-college",
  filterEducator: "tours-filter-educator",
  filterGroup: "tours-filter-group",
  card: (slug) => `tour-card-${slug}`,
  cardLink: (slug) => `tour-card-link-${slug}`,
};

export const TOUR_DETAIL = {
  hero: "tour-detail-hero",
  itinerary: "tour-detail-itinerary",
  requestBtn: "tour-detail-request-btn",
};

export const QUOTE = {
  formRoot: "quote-form-root",
  step1: "quote-step-1",
  step2: "quote-step-2",
  step3: "quote-step-3",
  nextBtn: "quote-next-btn",
  prevBtn: "quote-prev-btn",
  submitBtn: "quote-submit-btn",
  successPanel: "quote-success-panel",
  name: "quote-input-name",
  email: "quote-input-email",
  phone: "quote-input-phone",
  org: "quote-input-org",
  role: "quote-input-role",
  destination: "quote-input-destination",
  groupSize: "quote-input-group-size",
  window: "quote-input-window",
  duration: "quote-input-duration",
  budget: "quote-input-budget",
  message: "quote-input-message",
  tourSelect: "quote-input-tour",
  tripTypeCollege: "quote-trip-type-college",
  tripTypeGroup: "quote-trip-type-group",
};

export const ADMIN = {
  list: "admin-inquiry-list",
  refresh: "admin-refresh-btn",
  statsTotal: "admin-stats-total",
  statsNew: "admin-stats-new",
};

export const FOOTER = {
  root: "site-footer",
};
